import { onParseResponse } from "@/utils/axiosUtil";
const API_ENDPOINTS = {
  blog: "/api/blogs",
};

export const getBlogsForPublicAPI = async (params) => {
  const response = await onParseResponse({
    method: "get",
    url: API_ENDPOINTS.blog + "/public",
    params,
  });
  return response;
};

export const getBlogsForPublicBySlugAPI = async (slug) => {
  const response = await onParseResponse({
    method: "get",
    url: `${API_ENDPOINTS.blog}/public/${slug}`,
  });
  return response;
};

export const getUniqueBlogTagsAPI = async () => {
  const response = await onParseResponse({
    method: "get",
    url: `${API_ENDPOINTS.blog}/public/tags`,
  });
  return response;
};

export const getBlogCountsAPI = async () => {
  const response = await onParseResponse({
    method: "get",
    url: `${API_ENDPOINTS.blog}/counts`,
  });
  return response;
};

export const getBlogsAPI = async (params) => {
  const response = await onParseResponse({
    method: "get",
    url: API_ENDPOINTS.blog,
    params,
  });
  return response;
};

export const getBlogBySlugAPI = async (slug) => {
  const response = await onParseResponse({
    method: "get",
    url: `${API_ENDPOINTS.blog}/${slug}`,
  });
  return response;
};
